import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { SecurityConstants } from "../constants/security.constants";

@Injectable({
  providedIn: "root",
})
export class SecurityService {
  private authorizeEndpoint = SecurityConstants.authorizeEndpoint;
  private baseUrl = environment.apiUrl;
  private tokenKey = SecurityConstants.tokenKey;
  private serviceIdKey = SecurityConstants.serviceKey;
  private roleKey = SecurityConstants.roleKey;
  private serviceMapKey = SecurityConstants.serviceMapKey;

  constructor(private http: HttpClient) {}

  login() {
    window.open(this.baseUrl + this.authorizeEndpoint, "_self");
  }

  loginCheck(): boolean {
    const token = this.getToken();
    return !!token;
  }

  signOut(): void {
    try {
      localStorage.clear();
    } catch (ex) {
      console.log("Exception while clearing localStorage ", ex);
    }
  }

  updateUserInfo(res: any) {
    this.encodeServiceMap(res);
  }

  public getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  public getRoles(): string[] {
    const role = localStorage.getItem(this.roleKey);
    if (role) {
      return [role];
    }
    return [];
  }

  public setServiceId(serviceId: string) {
    localStorage.setItem(this.serviceIdKey, serviceId);
  }

  public setRole(role: string) {
    localStorage.setItem(this.roleKey, role);
  }

  private encodeServiceMap(serviceMap: { [key: string]: any }) {
    const jsonString = JSON.stringify(serviceMap);
    const encodedString = btoa(jsonString);
    localStorage.setItem(this.serviceMapKey, encodedString);
    const key = Object.keys(serviceMap)[0];
    this.setServiceId(key);
    this.setRole(serviceMap[key]);
  }

  public getServiceMap(): { [key: string]: any } {
    const encodedString = localStorage.getItem(this.serviceMapKey);
    if (!encodedString) {
      return {};
    }
    const decodedString = atob(encodedString);
    return JSON.parse(decodedString);
  }
}
